// Lets an overlay (the Check-up do barco panel, CN-190) own a browser history entry, so the phone
// "back" button closes it instead of leaving the page.
//
// The popstate listener must run before Inertia's: Inertia restores (re-mounts) the page on every
// popstate, which would wipe the page state. Browsers call listeners on window in registration order,
// so this module is imported by app.tsx before the Inertia app starts.

let closeOnBack: (() => void) | null = null;

if (typeof window !== 'undefined') {
    window.addEventListener('popstate', (event) => {
        if (!closeOnBack) return;

        const close = closeOnBack;
        closeOnBack = null;
        event.stopImmediatePropagation();
        close();
    });
}

/**
 * Adds a history entry for the open overlay; "back" will call close() instead of navigating.
 */
export function pushOverlayHistory(close: () => void): void {
    window.history.pushState(window.history.state, '', window.location.href);
    closeOnBack = close;
}

/**
 * Closes the overlay through history.back(). Returns false when the overlay owns no history entry.
 */
export function popOverlayHistory(): boolean {
    if (!closeOnBack) return false;

    window.history.back();
    return true;
}

/**
 * Forgets the overlay entry (e.g. it is replaced by a navigation or the page unmounts).
 */
export function releaseOverlayHistory(): void {
    closeOnBack = null;
}
